/**
 * Post-login / post-context-load routing for onboarding steps.
 * Dashboard requires account type selection and username (address/reps optional).
 */

export function canAccessDashboardFromContext(ctx) {
  if (!ctx) return false;
  return Boolean(ctx.hasSelectedAccountType && ctx.username);
}

/**
 * @param {object|null} ctx - User context from loadUserContext / fetchUserContext
 * @returns {"/dashboard"|"/account-type-selection"|"/setup-representative"}
 */
export function getOnboardingRedirectPath(ctx) {
  if (!ctx) {
    return "/setup-representative";
  }
  if (canAccessDashboardFromContext(ctx)) {
    return "/dashboard";
  }
  if (!ctx.hasSelectedAccountType) {
    return "/account-type-selection";
  }
  return "/setup-representative";
}

/**
 * Whether a failed login should trigger social new-user signup (backend has no row yet).
 * @param {number|undefined} status - HTTP status from login endpoint
 */
export function shouldTreatLoginFailureAsNewSocialUser(status) {
  return status === 404;
}
